<template>
  <ion-page>
    <ion-header>
      <LoggedInNav
        :title="'Contraseña'"
        :back="true"
        :backUrl="'/configuracion/datosPersonales'"
      />
    </ion-header>
    <ion-grid class="grid" v-if="step1">
      <ion-row>
        <ion-col class="grid__content">
          <h3 class="subtitle-1 ion-text-center">
            Para continuar, primero debes verificar tu identidad
          </h3>
        </ion-col>
      </ion-row>
      <ion-row class="w-100">
        <ion-col>
          <form @submit.prevent="enviar" novalidate>
            <div class="centerCenter">
              <ion-item mode="md">
                <ion-label position="floating" class="labelText"
                  >Contraseña</ion-label
                >
                <ion-input
                  :type="passwordFieldType"
                  name="password"
                  v-model="vv.password.$model"
                  v-bind="password"
                />
                <ion-icon
                  slot="end"
                  :icon="passwordEyeStyle"
                  @click="switchPasswordVisibility"
                  style="margin-top: 20px"
                ></ion-icon>
              </ion-item>
            </div>
          <div class="centerCenter">
            <div class="contenedor" v-if="showErrosPassword" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="
                    vv?.password?.$errors[0]?.$message === 'Value is required'
                  "
                >
                  Contraseña requerida
                </p>
              </div>
          </div>
            <div class="centerCenter" style="margin: 50px 0 5px 0">
              <span class="parrafo-small">
                ¿Olvidaste tu contraseña?
                <span
                  style="color: #e33613; font-weight: bold"
                  v-on:click="goToRecover"
                  >RECUPERAR</span
                >
              </span>
            </div>
          </form>
        </ion-col>
      </ion-row>
      <ion-row class="grid__actions">
        <ion-col>
          <div class="centerCenter">
            <ion-button
            class="btn buttonIniciar"
            expand="block"
            fill="solid"
            :disabled="vv?.password.$dirty == false"
            v-on:click="enviar1"
            >Siguiente</ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="grid" v-if="step2">
      <ion-row>
        <ion-col class="grid__content">
          <h3 class="subtitle-1 ion-text-center">Elige una contraseña nueva</h3>
        </ion-col>
      </ion-row>
      <ion-row class="w-100">
        <ion-col>
          <div class="centerCenter">
            <ion-item :class="newPasswordCorrect ? 'correct' : 'notCorrect'" mode="md">
              <ion-label
                position="floating"
                class="labelText"
                :class="newPasswordCorrect ? 'correctLabel' : 'notCorrectLabel'"
                >Nueva contraseña</ion-label
              >
              <ion-input
                :type="nuevoPasswordFieldType"
                name="nuevoPassword"
                v-model="vv.nuevoPassword.$model"
              />
              <ion-icon
                slot="end"
                :icon="nuevoPasswordEyeStyle"
                @click="switchNuevoPasswordVisibility"
                style="margin-top: 20px"
              ></ion-icon>
            </ion-item>
          </div>
          <div class="centerCenter">
            <div class="contenedor" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="
                    vv?.nuevoPassword?.$errors[0]?.$message === 'Value is required'
                  "
                >
                  Contraseña requerida
                </p>
              </div>
          </div>
          <div class="centerCenter">
            <div class="contenedor" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="
                    vv?.nuevoPassword?.$errors[0]?.$message ===
                    'This field should be at least 8 long.'
                  "
                >
                  Debe tener un mínimo de 8 caracteres.
                </p>
              </div>
          </div>
            
          <div class="centerCenter" style="margin-top: 20px">
            <ion-item mode="md"
              :class="newPasswordConfirmCorrect ? 'correct' : 'notCorrect'"
            >
              <ion-label
                position="floating"
                class="labelText"
                :class="
                  newPasswordConfirmCorrect ? 'correctLabel' : 'notCorrectLabel'
                "
                >Confirmar nueva contraseña</ion-label
              >
              <ion-input
                :type="repeatNuevoPasswordFieldType"
                name="repeatNuevoPassword"
                v-model="vv.repeatNuevoPassword.$model"
              />
              <ion-icon
                slot="end"
                :icon="repeatNuevoPasswordEyeStyle"
                @click="switchRepeatNuevoPasswordVisibility"
                style="margin-top: 20px"
              ></ion-icon>
            </ion-item>
          </div>
          <div class="centerCenter">
            <div class="contenedor" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="
                    vv?.repeatNuevoPassword?.$errors[0]?.$message ===
                    'Value is required'
                  "
                >
                  Contraseña requerida
                </p>
              </div>
          </div>
          <div class="centerCenter">
            <div class="contenedor" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="vv.repeatNuevoPassword.$model !== vv.nuevoPassword.$model"
                >
                  Las contraseñas deben ser iguales
                </p>
              </div>
          </div>

          <div class="centerCenter">
            <div class="contenedor" style="width: 100%; justify-content: left;">
                <p
                  class="error-msg"
                  v-if="
                    vv?.repeatNuevoPassword?.$errors[0]?.$message ===
                    'This field should be at least 8 long.'
                  "
                >
                  Debe tener un mínimo de 8 caracteres.
                </p>
              </div>
          </div>
            
        </ion-col>
      </ion-row>
      <ion-row class="grid__actions">
        <ion-col>
          <div class="centerCenter">
            <ion-button
              class="btn buttonIniciar"
              expand="block"
              fill="solid"
              v-on:click="openModal"
              :disabled="
                vv?.nuevoPassword?.$errors.length > 0 ||
                vv?.repeatNuevoPassword?.$errors.length > 0 ||
                vv?.nuevoPassword.$dirty == false ||
                vv?.repeatNuevoPassword.$dirty == false ||
                vv.repeatNuevoPassword.$model !== vv.nuevoPassword.$model
              "
              >Guardar</ion-button
            >
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import { reactive, toRef } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";
import {
  IonPage,
  IonCol,
  IonGrid,
  IonRow,
  IonHeader,
  IonButton,
  modalController,
  IonLabel,
  IonInput,
  IonItem,
} from "@ionic/vue";
import LoggedInNav from "../../../../components/LoggedInNav.vue";
import Modal from "../../../../components/Modals/ModalCambiarEmail.vue";
import AccountService from "../../../../services/account.service";
import { eyeOutline, eyeOffOutline } from "ionicons/icons";
import router from "../../../../router/index";
import { useStore } from "vuex";
export default defineComponent({
  name: "Contrasena",
  components: {
    IonPage,
    IonCol,
    IonGrid,
    IonRow,
    IonHeader,
    IonButton,
    LoggedInNav,
    IonLabel,
    IonInput,
    IonItem,
  },
  data() {
    return {
      step1: true,
      passwordFieldType: "password",
      passwordEyeStyle: eyeOffOutline,
      showErrosPassword: false,
      step2: false,
      nuevoPasswordFieldType: "password",
      nuevoPasswordEyeStyle: eyeOffOutline,
      repeatNuevoPasswordFieldType: "password",
      repeatNuevoPasswordEyeStyle: eyeOffOutline,
      password: "",
      fourDigit: false,
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      enviar1Button: false,
      newPasswordCorrect: false,
      newPasswordConfirmCorrect: false,
    };
  },
  watch: {
    vv() {
      if (
        this.vv.nuevoPassword.$errors.length === 0 &&
        this.vv.nuevoPassword.$dirty === true
      ) {
        this.newPasswordCorrect = true;
      } else {
        this.newPasswordCorrect = false;
      }
      if (
        this.vv.repeatNuevoPassword.$errors.length === 0 &&
        this.vv.repeatNuevoPassword.$dirty === true &&
        this.vv.repeatNuevoPassword.$model === this.vv.nuevoPassword.$model
      ) {
        this.newPasswordConfirmCorrect = true;
      } else {
        this.newPasswordConfirmCorrect = false;
      }
    },
  },
  setup() {
    const store = useStore();
    const fform = reactive({
      nuevoPassword: "",
      password: "",
      repeatNuevoPassword: "",
    });
    const rules = {
      nuevoPassword: { required, minLength: minLength(8) },
      password: { required },
      repeatNuevoPassword: { required, minLength: minLength(8) },
    };
    const vv = useVuelidate(rules, {
      nuevoPassword: toRef(fform, "nuevoPassword"),
      password: toRef(fform, "password"),
      repeatNuevoPassword: toRef(fform, "repeatNuevoPassword"),
    });

    const onSubmit = () => {
      vv.value.$touch();
      if (vv.value.$invalid) return;
    };
    return {
      store,
      onSubmit,
      vv,
      eyeOutline,
      eyeOffOutline,
    };
  },
  methods: {
    async openModal() {
      const modal = await modalController.create({
       component: Modal,
            mode: "md"
      });
      AccountService.changePassword({
        password: this.vv.nuevoPassword.$model,
      }).then((data) => {
        if (data === "success") {
          return modal.present();
        }
      });
    },
    switchPasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.passwordEyeStyle =
        this.passwordEyeStyle === eyeOffOutline ? eyeOutline : eyeOffOutline;
    },
    enviar1() {
      this.showErrosPassword = true;
      if (this.vv.password?.$errors.length === 0) {
        AccountService.checkPassword({
          password: this.vv.password.$model,
        }).then((data) => {
          if (data === "success") {
            (this.step1 = false), (this.step2 = true);
          }
        });
      }
    },
    switchNuevoPasswordVisibility() {
      this.nuevoPasswordFieldType =
        this.nuevoPasswordFieldType === "password" ? "text" : "password";
      this.nuevoPasswordEyeStyle =
        this.nuevoPasswordEyeStyle === eyeOffOutline
          ? eyeOutline
          : eyeOffOutline;
    },
    switchRepeatNuevoPasswordVisibility() {
      this.repeatNuevoPasswordFieldType =
        this.repeatNuevoPasswordFieldType === "password" ? "text" : "password";
      this.repeatNuevoPasswordEyeStyle =
        this.repeatNuevoPasswordEyeStyle === eyeOffOutline
          ? eyeOutline
          : eyeOffOutline;
    },
    goToRecover() {
      router.push("/recuperarPassword");
    },
  },
});
</script>
<style lang="scss" scoped>
.grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 38px 14px 35px;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;
  }

  &__actions {
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    align-items: flex-end;
  }
}

.label {
  display: flex;
  align-items: center;

  img {
    margin-right: 20px;
  }

  h5 {
    margin: 0;
  }
}

ion-item {
  border-radius: 10px 10px 0 0;
  border-bottom: 3px solid #b4b4b4;
  --background: white;
  margin-top: 10px;
  --highlight-color-focused: #d4692700;
  width: 100%;
  max-width: 700px;
}

ion-item.item-has-focus {
  border-bottom: 3px solid #d46927;
}

ion-item.item-has-focus > ion-label {
  color: #d46827;
}
</style>
